export interface DeviceStatisticsPayloadModel {
  nodeId?: string;
  deviceId?: string;
  timeRange: {
    from: number;
    to: number;
  }
}
